module.exports = "https://www.gc-qa.gnp.com.mx/21e636ba4896f1ed68ebff4d3021e98e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-17.jpg
// module id = 944
// module chunks = 0 1